export default "__VITE_ASSET__CaHRQJxp__"